import { Backend } from '@/_axios';

export default {
  myProfileData() {
    return Backend.get('/profile');
  },
  myProfileUpdate(data) {
    return Backend.put('/profile', data);
  },
};
